import BaseService from './BaseService'
import service from '.'
import api from './api'
import {toast} from '../util/decorators'

export default class NewsService extends BaseService {
  constructor () {
    super({
      list: [],
      type: 0,
      page: 0,
      pageSize: 20,
      news: 0
    })
  }

  get list () {
    return this.data.list
  }

  get type () {
    return this.data.type
  }

  set type (value) {
    this.data.type = value
  }

  clear () {
    this.data.list = []
    this.data.page = 0
  }

  @toast()
  async loadNext () {
    let body = await api.news.getPage({
      type: this.type,
      page: this.data.page + 1,
      pagesize: this.data.pageSize
    })
    if (this.data.page === 0) {
      this.data.list = body.data
    } else {
      this.data.list = [...this.data.list, ...body.data]
    }
    this.data.page++
    if (this.data.list.length > 0 && this.data.list[0].addtime > service.user.getLastNews()) {
      this.data.news = this.data.list[0].addtime
      service.user.readLastNews(this.data.news)
    }
  }

  async loadDetail (id) {
    return await api.news.getDetail({id})
  }

  async loadNews () {
    let body = await api.news.getPage({page: 1, pagesize: 1})
    if (body.data.length > 0) {
      this.data.news = body.data[0].addtime
    }
  }

  get unread () {
    return service.user.getLastNews() < this.data.news
  }
}




// WEBPACK FOOTER //
// ./src/service/NewsService.js